import {
    Directive,
    ElementRef,
    Renderer2,
    NgZone,
    OnDestroy
} from '@angular/core';

const SPEED_MULTIPLIER = 1.5;

@Directive({
    selector: '[libDraggableHorizontalScroll]',
    standalone: true
})
export class DraggableHorizontalScrollDirective implements OnDestroy {
    private isDragging = false;
    private startX = 0;
    private scrollLeft = 0;

    private mouseMoveListener?: () => void;
    private mouseUpListener?: () => void;

    constructor(
        private el: ElementRef,
        private renderer: Renderer2,
        private ngZone: NgZone
    ) {
        this.ngZone.runOutsideAngular(() => {
            this.renderer.listen(this.el.nativeElement, 'mousedown', this.onMouseDown);
        });
    }

    onMouseDown = (e: MouseEvent) => {
        this.isDragging = true;
        this.startX = e.pageX - this.el.nativeElement.offsetLeft;
        this.scrollLeft = this.el.nativeElement.scrollLeft;
        this.el.nativeElement.classList.add('active');

        this.mouseMoveListener = this.renderer.listen('document', 'mousemove', this.onMouseMove);
        this.mouseUpListener = this.renderer.listen('document', 'mouseup', this.onMouseUp);
    };

    onMouseMove = (e: MouseEvent) => {
        if (this.isDragging) {
            e.preventDefault();

            const elementX = e.pageX - this.el.nativeElement.offsetLeft;
            const movementDistance = (elementX - this.startX) * SPEED_MULTIPLIER;

            this.el.nativeElement.scrollLeft = this.scrollLeft - movementDistance;
        };
    };

    onMouseUp = () => {
        if (this.isDragging) {
            this.isDragging = false;
            this.el.nativeElement.classList.remove('active');

            this.mouseMoveListener?.();
            this.mouseUpListener?.();
        };
    };

    ngOnDestroy(): void {
        this.mouseMoveListener?.();
        this.mouseUpListener?.();
    }
}